class GridItemSwatches extends HTMLElement {
    constructor() {
        super();

        this.isKit = this.getAttribute('is-kit');
        this.currencySymbol = this.getAttribute('currency-symbol');
        this.productObj = this.getAttribute('product-object');

        this.product = [];
        this.swatches = [];
        this.selectedItem = 0;
    }

    connectedCallback() {

        if ($(this).closest(".slick-cloned").length) return;

        if (this.dataset.initialized) return;
        this.dataset.initialized = "true";

        if (this.isKit === "true") return;

        this.product = JSON.parse(this.productObj);
        this.returnSwatches();
    }

    returnSwatches() {
        let prdOptions = this.product.options,
            optionIndex = undefined;

        // Find the Color option index
        for (let i = 0; i < prdOptions.length; i++) {
            if (
                (typeof prdOptions[i] === "string" &&
                    prdOptions[i].toLowerCase() === "color") ||
                (prdOptions[i].name &&
                    prdOptions[i].name.toLowerCase() === "color")
            ) {
                optionIndex = i;
                break;
            }
        }

        if (optionIndex === undefined) return;

        let prdVariants = this.product.variants;

        if (prdVariants.length < 2) return;

        // Reset swatches
        this.swatches = [];

        // Prevent duplicate colors
        let addedColors = new Set();

        prdVariants.forEach((variant) => {

            let color = variant.options[optionIndex];

            if (addedColors.has(color)) return;

            addedColors.add(color);

            this.swatches.push({
                handle: this.product.handle + "?variant=" + variant.id,
                variantID: variant.id,
                available: variant.available,
                price: variant.price,
                compareAtPrice: variant.compare_at_price,
                name: color,
                img: variant.featured_image
                    ? variant.featured_image.src
                    : this.product.featured_image
            });
        });

        this.renderSwatches();
    }

    renderSwatches() {

        let swatchesWrapper = this.querySelector(".swatches-wrapper");

        if (!swatchesWrapper) return;

        // Remove existing swatches
        swatchesWrapper.innerHTML = "";

        this.swatches.forEach((swatch, i) => {

            let node = document.createElement("a");

            node.href = "/products/" + swatch.handle;
            node.className = "swatch-item";
            node.dataset.name = swatch.name;
            node.dataset.index = i;
            node.setAttribute("aria-label", swatch.name);

            if (
                window.swatches === undefined ||
                window.swatches[swatch.name] === undefined
            ) {
                node.style.backgroundImage = `url(${this.imgResize(
                    swatch.img,
                    80
                )})`;
            } else if (window.swatches[swatch.name].image) {
                node.style.backgroundImage = `url(${this.imgResize(
                    window.swatches[swatch.name].image,
                    80
                )})`;
            } else {
                node.style.backgroundColor =
                    window.swatches[swatch.name].color;
            }

            node.addEventListener("click", (e) => {
                e.preventDefault();
                this.colorChange(i);
            });

            swatchesWrapper.appendChild(node);
        });

        if (this.swatches.length) {
            this.colorChange(0);
            swatchesWrapper
                .querySelector(".swatch-item")
                ?.classList.add("selected");
        }

        this.preloadImages();

        this.querySelector(".variant-title")?.classList.remove("d-none");
        swatchesWrapper.classList.remove("d-none");
    }

    colorChange(i) {
        let swatches = this.querySelectorAll('.swatch-item'),
            swatchData = this.swatches[i],
            links = this.querySelectorAll('a'),
            prdImg = this.querySelector('.main-prd-img'),
            btn = this.querySelector('.js-btn-add-to-cart'),
            variantTitle = this.querySelector('.variant-title'),
            price = this.querySelector('.price'),
            compareAtPrice = this.querySelector('.compare-at-price');

        swatches.forEach(swatch => {
            swatch.classList.remove('selected');
        });

        swatches[i].classList.add('selected');

        links.forEach(link => {
            link.setAttribute('href', '/products/' + swatchData.handle);
        });

        prdImg.setAttribute('src', this.imgResize(swatchData.img, '600'));
        variantTitle.innerHTML = swatchData.name;

        btn.setAttribute(
            'onclick',
            `App.Nova.addToCart(event, '${this.product.handle}', ${swatchData.variantID}, null, 1)`
        );

        if (swatchData.available == true) {
            btn.querySelector('.text').innerHTML = 'Add to cart';
            btn.classList.remove('-disabled');
            btn.removeAttribute('disabled');
        } else {
            btn.querySelector('.text').innerHTML = 'Sold out';
            btn.classList.add('-disabled');
            btn.setAttribute('disabled', 'true');
        }

        if (swatchData.compareAtPrice !== null && swatchData.compareAtPrice > swatchData.price) {
            compareAtPrice.classList.remove('d-none');
            compareAtPrice.innerHTML = this.formatMoney(swatchData.compareAtPrice);
            price.innerHTML = this.formatMoney(swatchData.price);
        } else {
            compareAtPrice.classList.add('d-none');
            price.innerHTML = this.formatMoney(swatchData.price);
        }
    }

    preloadImages() {
        let images = [];
        window.addEventListener('load', () => {
            for (let i = 0; i < this.swatches.length; i++) {
                images[i] = new Image();
                images[i].src = this.imgResize(this.swatches[i].img, 600);
            }
        });
    }

    imgResize(value, width) {
        if (value == null) return;

        return `${value}&width=${width}`;
    }

    formatMoney(value) {
        const moneyFormat = this.currencySymbol + '{{amount_no_decimals}}';
        return this.shopifyFormatMoney(value, moneyFormat);
    }

    shopifyFormatMoney(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }

        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format;
        var symbol = this.currencySymbol;

        function defaultOption(opt, def) {
            return typeof opt == 'undefined' ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, symbol + '1' + thousands),
                cents = parts[1] ? decimal + parts[1] : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }
}

customElements.define('grid-item-swatches', GridItemSwatches);
